module.exports = __webpack_public_path__ + "static/media/dali-clocks.a7146733.jpg";